module.exports = __webpack_public_path__ + "img/xinlililun.b0ee9f0f.png";